import { createBrowserRouter } from "react-router-dom";
import Home from '../pages/Home';
import HowItWorks from '../pages/HowItWorks';
import Pricing from '../pages/Pricing';
import Connect from '../pages/Connect';
import SignUp from '../pages/SignUp';
import Layout from "../layout/Layout";
import PrivacyPolicy from "./../pages/PrivacyPolicy";

const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "/howitworks",
          element: <HowItWorks />,
        },
        {
          path: "/pricing",
          element: <Pricing />,
        },
        {
          path: "/connect",
          element: <Connect />,
        },
        {
          path: "/signup",
          element: <SignUp />,
        },
        {
          path: "/privacypolicy",
          element: <PrivacyPolicy />,
        }
      ]
    },
  ])
  
  export default router